var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25L10 2.5L2.5 6.25M17.5 6.25V13.75L10 17.5L2.5 13.75V6.25M17.5 6.25L10 10M2.5 6.25L10 10M10 10V17.0833M14.1667 10.8333V7.91667L6.66667 4.16667",
    stroke: "#0F0F0F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 10.7002C16.4528 10.7002 16.8837 10.7865 17.2881 10.9609L17.5771 11.1016C17.8576 11.2539 18.1104 11.4418 18.334 11.665L18.4424 11.7783C18.6897 12.0502 18.8885 12.362 19.0391 12.7109C19.2134 13.1151 19.2998 13.5454 19.2998 13.999C19.2998 14.396 19.2338 14.7752 19.1006 15.1348L19.0391 15.2881C18.8674 15.6866 18.6329 16.0362 18.335 16.334C18.1115 16.5573 17.8591 16.7458 17.5791 16.8984L17.29 17.0391C16.9366 17.1921 16.5624 17.2771 16.1699 17.2959L16.001 17.2998C15.604 17.2998 15.2248 17.2338 14.8652 17.1006L14.7119 17.0391C14.3634 16.8886 14.0523 16.6901 13.7803 16.4434L13.666 16.335C13.4424 16.1116 13.2542 15.8592 13.1016 15.5791L12.9609 15.29C12.7864 14.8861 12.7002 14.4551 12.7002 14.001C12.7002 13.5468 12.7865 13.116 12.9609 12.7119L13.1016 12.4229C13.2538 12.1425 13.441 11.8896 13.6641 11.666C13.9616 11.3678 14.3113 11.1329 14.71 10.9609L14.8633 10.8994C15.2228 10.7661 15.6021 10.7002 15.999 10.7002Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledIcon);
export default __webpack_public_path__ + "static/media/cancelledIcon.25d80087cd8b21c8f6640fb7e0e1cae3.svg";
export { ForwardRef as ReactComponent };